import { render, staticRenderFns } from "./ContentLoading.vue?vue&type=template&id=8908f054&scoped=true"
import script from "./ContentLoading.vue?vue&type=script&lang=js"
export * from "./ContentLoading.vue?vue&type=script&lang=js"
import style0 from "./ContentLoading.vue?vue&type=style&index=0&id=8908f054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8908f054",
  null
  
)

export default component.exports